import { Typography, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';
import {
  SparkFormTaggedTextField,
  SparkDropdown,
  SparkTextField,
  SparkBasicFormFooter,
} from 'sharedComponents/SparkForm';
import type { DropdownOption } from 'types/common/DropdownOption';
import { SparkResourceSharePopoverValues } from './SparkResourceSharePopover';

type AccessLinkSectionProps = { accessLevelDropdownOptions: DropdownOption[] };

function AccessLinkSection({
  accessLevelDropdownOptions,
}: AccessLinkSectionProps) {
  const { values } = useFormikContext<SparkResourceSharePopoverValues>();
  const emails = values.individualEmails;
  return (
    <Grid container padding={2} gap={1}>
      <Typography
        sx={{
          color: 'black',
          fontSize: '18px',
          fontFamily: 'Mont-SemiBold',
          paddingLeft: 2,
        }}
      >
        Individual Access
      </Typography>
      <Grid container item xs={12} gap={2} flexWrap='nowrap'>
        <SparkFormTaggedTextField
          name='individualEmails'
          label=''
          placeholder='Add people'
          type='email'
        />
        <SparkDropdown
          name='individualAccessLevelID'
          label=''
          menuItemProps={{ divider: false }}
        >
          {accessLevelDropdownOptions}
        </SparkDropdown>
      </Grid>
      {emails.length > 0 && (
        <>
          <SparkTextField
            name='inviteMessage'
            placeholder='Add a custom message'
            label=''
            multiline
            rows={3}
            size={12}
          />
          <SparkBasicFormFooter
            shouldRenderResetButton
            primaryButtonText='Invite'
            resetButtonText='cancel'
            shouldRequireFieldUpdates={true}
          />
        </>
      )}
    </Grid>
  );
}

export default AccessLinkSection;
